// src/pages/Categories/components/CategoryList.tsx
import React from 'react'
import type { Category } from '../../../types/@types/category'
import { Pencil, Trash2, FolderOpen } from 'lucide-react'

interface CategoryListProps {
  categories: Category[]
  onEdit: (category: Category) => void
  onDelete: (id: string) => void
}

const CategoryList: React.FC<CategoryListProps> = ({ categories, onEdit, onDelete }) => {
  if (categories.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-14 text-center px-6">
        <div className="rounded-2xl bg-muted p-4">
          <FolderOpen size={28} className="text-text-muted" />
        </div>
        <div>
          <p className="font-semibold text-text">Sin categorías</p>
          <p className="mt-0.5 text-sm text-text-muted">Crea la primera usando el formulario</p>
        </div>
      </div>
    )
  }

  return (
    <ul className="divide-y divide-border">
      {categories.map((category) => (
        <li
          key={category.id}
          className="flex items-center gap-3 px-5 py-4 transition-colors hover:bg-muted/40"
        >
          {/* Icon */}
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-border bg-muted text-xl">
            {category.icon}
          </div>

          {/* Info */}
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-semibold text-text">{category.name}</p>
            <p className="text-xs text-text-muted">
              {category.createdAt ? new Date(category.createdAt).toLocaleDateString() : '—'}
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-shrink-0 items-center gap-1">
            <button
              onClick={() => onEdit(category)}
              className="flex h-8 w-8 items-center justify-center rounded-lg text-text-muted transition-all hover:bg-primary/10 hover:text-primary active:scale-90"
              aria-label={`Editar ${category.name}`}
            >
              <Pencil size={15} />
            </button>
            <button
              onClick={() => onDelete(category.id)}
              className="flex h-8 w-8 items-center justify-center rounded-lg text-text-muted transition-all hover:bg-danger/10 hover:text-danger active:scale-90"
              aria-label={`Eliminar ${category.name}`}
            >
              <Trash2 size={15} />
            </button>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default CategoryList
